// 会员中心服务页面特殊处理
;(function ($) {
    $(document).ready(function () {

        // product_type 只在产品页面有，try一下避免报错
        try {
            // 针对小程序的特殊处理
            // 先使用cookie判断是否来自小程序
            if(common.isXCX()){
                $('.solution-footer').hide(); //导航
            }

            // 再使用jssdk判断是否是小程序环境，不是小程序环境再显示导航,这样可以保证小程序中打开时导航不会出现闪烁
            common.isFromXCXDef(function (res) {
                if(!res){
                    $('.solution-footer').show(); //导航
                }
            });

            // 6 为售后服务产品
            if(product_type !== 6){
                return;
            }


            $('.m-products-tab').hide()
            $('.product-details-page').css('padding-top','0')
            $('.no-flash-picture').hide();
            $('.product-vip-box').hide();
            // $('.product-options-wrapper .j-showAddCartDialog').hide();
            // $('.m-related-box').hide();
            $('.menu-cart').hide();
            $('.menu-add-to-cart').hide();
            $('.j-comment-box').hide();
            $('.j-award-box').hide();
            $('.j-attribute-box').hide();
            $('.j-after-sale-box').hide();
            $('.wishlist-btn').hide();
            $('.assist-side-light-reg').hide();
            // $('#product-form').hide();
            // $('#smart-rec').hide();
            $('#areaTrigger').hide();
            $('.solution-footer').hide(); //导航

            $('.button-add-to-cart').hide();
            $('.buy-now-fgf-btn').css({'margin-left':'0', 'width':'7rem'});

            // pc端
            // 加入购物清单按钮
            $('.product-cart-nav .btn-blue-color').hide();

            // 提示文案
            $('.t-flash-max-quantity').hide();

            // 规格
            $('#tab-specification').hide();
            $("[data-target-id='tab-specification']").hide();
            function getServiceYear() {
              if (common.getCookie('service_tag')) {
                getJson(solution_host + '/api/services/servicesYear', {serviceTag:common.getCookie('service_tag')}, function (res) {
                  if (res.errCode === 0) {
                    $('#input-quantity').val(res.data.year)
                    window.cateData.maxNum=res.data.year
                  }
                });
              }
            }

          if(common.getCookie('service_tag')){
            getServiceYear();
          }
        }catch (e) {

        }

    })
})(jQuery);
